<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';
	import { Modal, Container, Stack, AdvancedCard, Button } from '@Shelly/shelly-design-system';

	export let showModal = false;

	const dispatch = createEventDispatcher();

	const handleCreateAction = () => {
		dispatch('create');
	};

	const handleImportAction = () => {
		dispatch('import');
	};

	const handleClose = () => {
		showModal = false;
		dispatch('close');
	};
</script>

<Modal
	title={$format('choose_action_type', { default: 'Choose action type' })}
	bind:showModal
	on:close={handleClose}
	size="m"
>
	<Container padding="0" slot="content">
		<Stack gap="m">
			<AdvancedCard
				avatar={{
					icon: 'fas fa-plus-circle',
				}}
				title={$format('create_action', { default: 'Create action' })}
				on:click={handleCreateAction}
				interactive
				isFocusable
				aria-label={$format('create_action', { default: 'Create action' })}
			/>
			<AdvancedCard
				avatar={{
					icon: 'fas fa-file-import',
				}}
				title={$format('import_action', { default: 'Import action' })}
				on:click={handleImportAction}
				interactive
				isFocusable
				aria-label={$format('import_action', { default: 'Import action' })}
			/>
		</Stack>
	</Container>

	<div slot="footer" class="d-flex justify-content-end width-full">
		<Button variant="secondary" on:click={handleClose}>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
	</div>
</Modal>
